// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 4l-4 4h8z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 8l4-4H2z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M4 6l4-4v8z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M8 6l-4 4V2z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.table-header-container {
  flex-shrink: 0;
  overflow-x: auto;
  overflow-y: hidden;
  /* Hide scrollbar for header */
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
  z-index: 10;
}

.table-header-container::-webkit-scrollbar {
  display: none;
}

.table-body-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
}

/* Scrollbar styling for table body container */
.table-body-container::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.table-body-container::-webkit-scrollbar-track {
  background: #f5f6f7;
}

.table-body-container::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 6px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.table-body-container::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
  background-clip: padding-box;
}

/* Scrollbar buttons (arrows) */
.table-body-container::-webkit-scrollbar-button {
  background-color: #f5f6f7;
  height: 16px;
  width: 16px;
  border-radius: 2px;
}

.table-body-container::-webkit-scrollbar-button:hover {
  background-color: #d1d5db;
}

/* Up arrow */
.table-body-container::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
}

/* Down arrow */
.table-body-container::-webkit-scrollbar-button:vertical:increment {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
}

/* Left arrow */
.table-body-container::-webkit-scrollbar-button:horizontal:decrement {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
}

/* Right arrow */
.table-body-container::-webkit-scrollbar-button:horizontal:increment {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
}

.reusable-table {
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
}

.reusable-table thead {
  background: #ffffff;
}

.reusable-table th {
  padding: 8px 16px;
  text-align: left;
  font-weight: 600;
  color: #1f2937;
  border-bottom: 2px solid #e5e7eb;
  background: #ffffff;
  text-transform: none;
  font-size: 14px;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  z-index: 1;
  min-width: 150px;
  max-width: 100%;
}

.reusable-table td {
  padding: 8px 16px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 150px;
  max-width: 100%;
}

.reusable-table tbody tr {
  background: #ffffff;
}

.reusable-table tbody tr:hover {
  background: #fafafa;
}

.reusable-table tbody tr.selectable-row {
  cursor: pointer;
}

.reusable-table th:first-child,
.reusable-table td:first-child {
  text-align: center;
  min-width: unset !important;
  text-overflow: clip;
  overflow: visible;
}

.table-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  border: 2px solid #cbd5e0;
  border-radius: 3px;
  position: relative;
  outline: none;
}

.table-checkbox:hover {
  border-color: #028661;
}

.table-checkbox:checked {
  background-color: #028661;
  border-color: #028661;
}

.table-checkbox:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.table-loading,
.table-empty {
  text-align: center;
  padding: 40px;
  color: #666;
}

.table-actions {
  display: flex;
  gap: 0;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}

.btn-icon {
  background: none;
  border: none;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
  border-radius: 4px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-edit {
  color: #14b8a6;
  font-size: 14px;
}

.btn-edit:hover {
  color: #0d9488;
}

.btn-delete {
  color: #ef4444;
}

.btn-delete:hover {
  color: #dc2626;
}

/* Pagination */
.table-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-top: auto;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
  flex-shrink: 0;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-controls {
  display: flex;
  gap: 4px;
  align-items: center;
}

.pagination-btn {
  min-width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background: white;
  color: #6b7280;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
  background: #f9fafb;
  color: #028661;
}

.pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-indicator {
  padding: 0 12px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  min-width: 60px;
  text-align: center;
}

/* Page size controls */
.pagination-pagesize {
  position: relative;
}

.pagination-pagesize label {
  position: absolute;
  top: -6px;
  left: 12px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  pointer-events: none;
  z-index: 1;
  line-height: 1;
  background: #ffffff;
  padding: 0 4px;
}

.pagesize-select {
  padding: 8px 32px 8px 12px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  min-width: 80px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  box-sizing: border-box;
}

.pagesize-select:hover {
  border-color: #9ca3af;
}

.pagesize-select:focus {
  outline: none;
  border-color: #028661;
  box-shadow: 0 0 0 3px rgba(2, 134, 97, 0.1);
}

/* Sort controls */
.pagination-sort {
  position: relative;
}

.pagination-sort label {
  position: absolute;
  top: -6px;
  left: 12px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  pointer-events: none;
  z-index: 1;
  line-height: 1;
  background: #ffffff;
  padding: 0 4px;
}

.pagination-sort>div {
  display: flex;
  gap: 4px;
  align-items: center;
}

.sort-select {
  padding: 8px 32px 8px 12px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  min-width: 180px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  box-sizing: border-box;
}

.sort-select:hover {
  border-color: #9ca3af;
}

.sort-select:focus {
  outline: none;
  border-color: #028661;
  box-shadow: 0 0 0 3px rgba(2, 134, 97, 0.1);
}

.sort-direction-btn {
  min-width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sort-direction-btn:hover:not(:disabled) {
  background: #f9fafb;
  color: #028661;
}

.sort-direction-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .table-pagination {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .pagination-left,
  .pagination-right {
    justify-content: center;
  }

  .pagination-right {
    flex-direction: column;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,yDAAmL;EACnL,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,yDAAkL;EAClL,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,yDAAkL;EAClL,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,yDAAmL;EACnL,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yDAAkL;EAClL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yDAAkL;EAClL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".table-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.table-header-container {\n  flex-shrink: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  /* Hide scrollbar for header */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  position: relative;\n  z-index: 10;\n}\n\n.table-header-container::-webkit-scrollbar {\n  display: none;\n}\n\n.table-body-container {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: auto;\n  min-height: 0;\n}\n\n/* Scrollbar styling for table body container */\n.table-body-container::-webkit-scrollbar {\n  width: 12px;\n  height: 12px;\n}\n\n.table-body-container::-webkit-scrollbar-track {\n  background: #f5f6f7;\n}\n\n.table-body-container::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 6px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.table-body-container::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n  background-clip: padding-box;\n}\n\n/* Scrollbar buttons (arrows) */\n.table-body-container::-webkit-scrollbar-button {\n  background-color: #f5f6f7;\n  height: 16px;\n  width: 16px;\n  border-radius: 2px;\n}\n\n.table-body-container::-webkit-scrollbar-button:hover {\n  background-color: #d1d5db;\n}\n\n/* Up arrow */\n.table-body-container::-webkit-scrollbar-button:vertical:decrement {\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 4l-4 4h8z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 8px;\n}\n\n/* Down arrow */\n.table-body-container::-webkit-scrollbar-button:vertical:increment {\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 8l4-4H2z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 8px;\n}\n\n/* Left arrow */\n.table-body-container::-webkit-scrollbar-button:horizontal:decrement {\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M4 6l4-4v8z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 8px;\n}\n\n/* Right arrow */\n.table-body-container::-webkit-scrollbar-button:horizontal:increment {\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M8 6l-4 4V2z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 8px;\n}\n\n.reusable-table {\n  width: 100%;\n  min-width: max-content;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: fixed;\n}\n\n.reusable-table thead {\n  background: #ffffff;\n}\n\n.reusable-table th {\n  padding: 8px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #1f2937;\n  border-bottom: 2px solid #e5e7eb;\n  background: #ffffff;\n  text-transform: none;\n  font-size: 14px;\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  z-index: 1;\n  min-width: 150px;\n  max-width: 100%;\n}\n\n.reusable-table td {\n  padding: 8px 16px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 150px;\n  max-width: 100%;\n}\n\n.reusable-table tbody tr {\n  background: #ffffff;\n}\n\n.reusable-table tbody tr:hover {\n  background: #fafafa;\n}\n\n.reusable-table tbody tr.selectable-row {\n  cursor: pointer;\n}\n\n.reusable-table th:first-child,\n.reusable-table td:first-child {\n  text-align: center;\n  min-width: unset !important;\n  text-overflow: clip;\n  overflow: visible;\n}\n\n.table-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: white;\n  border: 2px solid #cbd5e0;\n  border-radius: 3px;\n  position: relative;\n  outline: none;\n}\n\n.table-checkbox:hover {\n  border-color: #028661;\n}\n\n.table-checkbox:checked {\n  background-color: #028661;\n  border-color: #028661;\n}\n\n.table-checkbox:checked::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.table-loading,\n.table-empty {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.table-actions {\n  display: flex;\n  gap: 0;\n  align-items: center;\n  justify-content: flex-start;\n  white-space: nowrap;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  padding: 6px 8px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.2s;\n  border-radius: 4px;\n}\n\n.btn-icon:hover {\n  background-color: #f3f4f6;\n}\n\n.btn-edit {\n  color: #14b8a6;\n  font-size: 14px;\n}\n\n.btn-edit:hover {\n  color: #0d9488;\n}\n\n.btn-delete {\n  color: #ef4444;\n}\n\n.btn-delete:hover {\n  color: #dc2626;\n}\n\n/* Pagination */\n.table-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  margin-top: auto;\n  border-top: 1px solid #e5e7eb;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.pagination-left {\n  display: flex;\n  align-items: center;\n}\n\n.pagination-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.pagination-btn {\n  min-width: 36px;\n  height: 36px;\n  padding: 0;\n  border: none;\n  background: white;\n  color: #6b7280;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: #f9fafb;\n  color: #028661;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.page-indicator {\n  padding: 0 12px;\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Page size controls */\n.pagination-pagesize {\n  position: relative;\n}\n\n.pagination-pagesize label {\n  position: absolute;\n  top: -6px;\n  left: 12px;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  pointer-events: none;\n  z-index: 1;\n  line-height: 1;\n  background: #ffffff;\n  padding: 0 4px;\n}\n\n.pagesize-select {\n  padding: 8px 32px 8px 12px;\n  height: 36px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  font-size: 13px;\n  color: #374151;\n  min-width: 80px;\n  appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 8l4-4H2z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px;\n  box-sizing: border-box;\n}\n\n.pagesize-select:hover {\n  border-color: #9ca3af;\n}\n\n.pagesize-select:focus {\n  outline: none;\n  border-color: #028661;\n  box-shadow: 0 0 0 3px rgba(2, 134, 97, 0.1);\n}\n\n/* Sort controls */\n.pagination-sort {\n  position: relative;\n}\n\n.pagination-sort label {\n  position: absolute;\n  top: -6px;\n  left: 12px;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  pointer-events: none;\n  z-index: 1;\n  line-height: 1;\n  background: #ffffff;\n  padding: 0 4px;\n}\n\n.pagination-sort>div {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.sort-select {\n  padding: 8px 32px 8px 12px;\n  height: 36px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  font-size: 13px;\n  color: #374151;\n  min-width: 180px;\n  appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><path fill=\"%23374151\" d=\"M6 8l4-4H2z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px;\n  box-sizing: border-box;\n}\n\n.sort-select:hover {\n  border-color: #9ca3af;\n}\n\n.sort-select:focus {\n  outline: none;\n  border-color: #028661;\n  box-shadow: 0 0 0 3px rgba(2, 134, 97, 0.1);\n}\n\n.sort-direction-btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  font-size: 14px;\n  color: #374151;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sort-direction-btn:hover:not(:disabled) {\n  background: #f9fafb;\n  color: #028661;\n}\n\n.sort-direction-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .table-pagination {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n\n  .pagination-left,\n  .pagination-right {\n    justify-content: center;\n  }\n\n  .pagination-right {\n    flex-direction: column;\n    gap: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
